import { makeButton } from "@client/content/modules/Button";
import { type ButtonContainerProps } from "@client/content/modules/Button/container";
import { TargetSelector } from "@client/selectors";

export const Button = makeButton<ButtonContainerProps>(TargetSelector.Entity, "button");
export const PopupButton = makeButton<ButtonContainerProps>(TargetSelector.Entity, "popup.button");
